// extracted by mini-css-extract-plugin
export default {"navLinks":"Footer_navLinks__TAkB+","socialSection":"Footer_socialSection__tZQnP"};